module.exports = __webpack_public_path__ + "img/regpage_carousel.bfb3eba1.png";